import '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1xc4t1",
  styles: "display:flex;list-style-type:none;align-items:center;flex-wrap:wrap"
} : {
  name: "1k6fs65-getBreadcrumbStyles",
  styles: "display:flex;list-style-type:none;align-items:center;flex-wrap:wrap;label:getBreadcrumbStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJyZWFkY3J1bWJTdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0kiLCJmaWxlIjoiQnJlYWRjcnVtYlN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywgU2VyaWFsaXplZFN0eWxlcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuZXhwb3J0IGNvbnN0IGdldEJyZWFkY3J1bWJTdHlsZXMgPSAoKTogU2VyaWFsaXplZFN0eWxlcyA9PlxuICAgIGNzcyh7XG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcbiAgICAgICAgbGlzdFN0eWxlVHlwZTogJ25vbmUnLFxuICAgICAgICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcbiAgICAgICAgZmxleFdyYXA6ICd3cmFwJyxcbiAgICB9KTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const getBreadcrumbStyles = () => _ref;

export { getBreadcrumbStyles };
//# sourceMappingURL=BreadcrumbStyles.js.map
